/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=57f64d6c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=57f64d6c&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__